import React from 'react';

const LOGO_URL = "/media/migrated/e6c39fa4258dc208ae6f0e22b49a16441146ed1ce6742b073c6e7d8b6b291a9d.png";

const LogoIcon = ({ className = "w-[52px] h-[52px]" }) => {
  return (
    <img
      src={LOGO_URL}
      alt="R. Venue Logo"
      className={`object-contain ${className}`}
    />
  );
};

export default LogoIcon;